import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../Components/Index';
import { extractErrorMessage } from '../../services/api/errorHandler';
import { recognizePlate } from '../../services/api/plateRecognitionApi';
import CameraViewport from './components/CameraViewport';
import CaptureError from './components/CaptureError';
import GalleryFileInput from './components/GalleryFileInput';
import ImagePreview from './components/ImagePreview';
import useCamera from './hooks/useCamera';
import { captureVideoFrame, createImageUrl, validateImageFile } from './imageUtils';
import { extractPlateFromResponse } from './plateUtils';

export default function PlateCapture() {
  const navigate = useNavigate();
  const location = useLocation();
  const camera = useCamera();
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [error, setError] = useState('');
  const [processing, setProcessing] = useState(false);

  useEffect(() => () => {
    if (image?.url) URL.revokeObjectURL(image.url);
  }, [image]);

  const selectImage = file => {
    const validationError = validateImageFile(file);
    if (validationError) {
      setError(validationError);
      return;
    }
    setError('');
    camera.stop();
    setImage({ file, url: createImageUrl(file) });
  };

  const takePhoto = async () => {
    setError('');
    try {
      selectImage(await captureVideoFrame(camera.videoRef.current));
    } catch (captureError) {
      setError(captureError.message || 'گرفتن عکس ممکن نشد.');
    }
  };

  const retry = () => {
    setImage(null);
    setError('');
    window.requestAnimationFrame(() => camera.start());
  };

  const continueWithoutImage = () => navigate('/ServiceTwo', {
    state: { ...(location.state || {}), searchMode: 'plate', plateCaptureCompleted: true },
  });

  const processImage = async () => {
    if (!image?.file || processing) return;
    setProcessing(true);
    setError('');
    try {
      const response = await recognizePlate(image.file);
      const recognizedPlate = extractPlateFromResponse(response);
      if (!recognizedPlate) throw new Error('پلاک از روی تصویر خوانده نشد؛ عکس واضح‌تری بگیرید یا دستی ادامه دهید.');
      navigate('/ServiceTwo', {
        state: { ...(location.state || {}), searchMode: 'plate', recognizedPlate, plateCaptureCompleted: true },
      });
    } catch (recognitionError) {
      setError(extractErrorMessage(recognitionError, recognitionError.message || 'پردازش تصویر با خطا مواجه شد.'));
    } finally {
      setProcessing(false);
    }
  };

  return <main className="plate-capture" dir="rtl">
    <Header Text="اسکن خودرو و پلاک" LinkR="/ServiceDashbord" hideR="" showNotification={false} />
    <div className="plate-capture__content">
      {!image ? <CameraViewport camera={camera} onCapture={takePhoto} onSelectGallery={() => fileInputRef.current?.click()} onManualEntry={continueWithoutImage} /> : <ImagePreview imageUrl={image.url} file={image.file} processing={processing} onRetry={retry} onSubmit={processImage} />}

      <CaptureError message={error} />
      {!image && <GalleryFileInput inputRef={fileInputRef} onSelect={selectImage} />}

    </div>
  </main>;
}
